import {Anchor} from "../core/Anchor";
import {HoverableButton, TextureButton} from "../core/Button";
import {Mix} from "../core/Reflection";
import {TrashType} from "../data/TrashType";
import { ColorOverlayFilter } from "../filters/ColorOverlayFilter";
import { OutlineFilter } from "../filters/OutlineFilter";
import { Button, PulsatingButton } from "./Button";

export class TrashBin extends Button {

    public readonly trashType: TrashType[];
    protected overlayfilter = new ColorOverlayFilter(0xffffff, 0.5);
    protected outlineFilter = new OutlineFilter(5, 0xffff00);
    protected _highlighted: boolean = false;

    public get highlighted() { return this._highlighted; }

    constructor(trashType: TrashType | TrashType[], hoverVO: string) {
        super();
        if (trashType instanceof Array) {
            this.trashType = trashType;
        }
        else {
            this.trashType = [trashType];
        }

        this.filters = [this.overlayfilter, this.outlineFilter];
        this.overlayfilter.enabled = false;
        this.outlineFilter.enabled = false;
        this.hoverVO = hoverVO;

        // this.onOver.add(() => {
        //     this.Highlight();
        // });

        // this.onOut.add(() => {
        //     this.UnHighlight();
        // });
    }

    public Disable() {
        this.enabled = false;
        this.overlayfilter.enabled = true;
        this.UnHighlight();
    }

    public Enable() {
        this.enabled = true;
        this.overlayfilter.enabled = false;
    }

    public Highlight() {
        if (this.enabled) {
            this._highlighted = true;
            this.outlineFilter.enabled = true;
        }
    }

    public UnHighlight() {
        this._highlighted = false;
        this.outlineFilter.enabled = false;
    }
}
